{
  "familyId": "GELD-KOOPJES",
  "questions": [
    {
      "id": "GELD-KOOPJES-001",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een groenteboer vergelijkt aanbiedingen. 3 appels kosten €1,50. 5 appels kosten €2,00. Welke aanbieding is goedkoper per appel?",
      "options": ["5 appels voor €2,00", "3 appels voor €1,50", "beide even duur", "kan je niet uitrekenen"],
      "correctAnswer": 0,
      "conceptId": "price_comparison_apples",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Prijs per stuk berekenen", "content": "Deel de prijs door het aantal. 3 appels: €1,50 ÷ 3 = €0,50 per appel. 5 appels: €2,00 ÷ 5 = €0,40 per appel. €0,40 < €0,50 → 5 appels is goedkoper per stuk.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Bereken de prijs per stuk door de totaalprijs te delen door het aantal. 3 appels: €1,50 ÷ 3 = €0,50 per appel. 5 appels: €2,00 ÷ 5 = €0,40 per appel. €0,40 < €0,50, dus 5 appels voor €2,00 is goedkoper per appel.",
        "solutionSteps": ["Bereken prijs per stuk aanbieding 1: €1,50 ÷ 3 = €0,50 per appel", "Bereken prijs per stuk aanbieding 2: €2,00 ÷ 5 = €0,40 per appel", "Vergelijk: €0,40 < €0,50", "Conclusie: 5 appels voor €2,00 is goedkoper per appel ✓"],
        "distractorExplanations": {
          "0": "Goed! €2,00 ÷ 5 = €0,40 per appel — dat is 10 cent goedkoper dan €1,50 ÷ 3 = €0,50 per appel.",
          "1": "Je dacht waarschijnlijk dat de laagste totaalprijs automatisch het goedkoopst is. €1,50 is minder dan €2,00, maar per appel is het duurder: €0,50 vs. €0,40. Onthoud: vergelijk altijd de prijs per stuk, niet de totaalprijs.",
          "2": "Je dacht waarschijnlijk dat het niet uitmaakt. Maar ze zijn niet even duur per stuk: €0,50 vs. €0,40 per appel — dat is 10 cent verschil. Onthoud: bereken de prijs per stuk om eerlijk te vergelijken.",
          "3": "Je dacht waarschijnlijk dat je het niet kunt uitrekenen. Maar deel de prijs door het aantal: €1,50 ÷ 3 = €0,50 en €2,00 ÷ 5 = €0,40. Onthoud: prijs per stuk = totaalprijs ÷ aantal."
        }
      }
    },
    {
      "id": "GELD-KOOPJES-002",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een zuivelboer verkoopt yoghurt. Een pak van 6 yoghurtjes kost €3,00. Losse yoghurtjes kosten €0,60 per stuk. Hoeveel bespaar je per yoghurtje als je het pak koopt?",
      "options": ["€0,10", "€0,20", "€0,50", "€0,05"],
      "correctAnswer": 0,
      "conceptId": "price_comparison_savings",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Besparing per stuk berekenen", "content": "Pakprijs per stuk: €3,00 ÷ 6 = €0,50. Losse prijs: €0,60. Besparing: €0,60 − €0,50 = €0,10 per yoghurtje.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Bereken de prijs per stuk in het pak en vergelijk met de losse prijs. Pakprijs per yoghurtje: €3,00 ÷ 6 = €0,50. Losse prijs: €0,60. Besparing = €0,60 − €0,50 = €0,10 per yoghurtje.",
        "solutionSteps": ["Bereken pakprijs per stuk: €3,00 ÷ 6 = €0,50", "Losse prijs per stuk: €0,60", "Bereken besparing: €0,60 − €0,50 = €0,10", "Conclusie: je bespaart €0,10 per yoghurtje ✓"],
        "distractorExplanations": {
          "0": "Goed! €3,00 ÷ 6 = €0,50 per stuk in het pak. Besparing: €0,60 − €0,50 = €0,10 per yoghurtje.",
          "1": "Je dacht waarschijnlijk dat de pakprijs per stuk €0,40 is. Maar €3,00 ÷ 6 = €0,50, niet €0,40. Besparing: €0,60 − €0,50 = €0,10, niet €0,20. Onthoud: controleer je deling zorgvuldig.",
          "2": "Je dacht waarschijnlijk dat €0,50 de besparing is. Maar €0,50 is de prijs per yoghurtje in het pak, niet de besparing. Besparing = losse prijs − pakprijs = €0,60 − €0,50 = €0,10. Onthoud: besparing = verschil tussen de twee prijzen.",
          "3": "Je dacht waarschijnlijk dat de pakprijs per stuk €0,55 is. Maar €3,00 ÷ 6 = €0,50, niet €0,55. Besparing: €0,60 − €0,50 = €0,10, niet €0,05. Onthoud: deel de totaalprijs precies door het aantal."
        }
      }
    },
    {
      "id": "GELD-KOOPJES-003",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een kantoorboekhandelaar vergelijkt leveranciers. Winkel A verkoopt een pen voor €1,20. Winkel B heeft een aanbieding: 3 pennen voor €3,00. Waar is één pen goedkoper?",
      "options": ["Winkel B", "Winkel A", "beide even duur", "Winkel B is duurder"],
      "correctAnswer": 0,
      "conceptId": "price_comparison_stores",
      "variantIndex": 3,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.79,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Prijs per pen vergelijken", "content": "Winkel A: €1,20 per pen. Winkel B: €3,00 ÷ 3 = €1,00 per pen. €1,00 < €1,20 → Winkel B is goedkoper per pen.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Bereken de prijs per stuk bij beide winkels en vergelijk. Winkel A: €1,20 per pen. Winkel B: €3,00 ÷ 3 = €1,00 per pen. €1,00 < €1,20, dus Winkel B is goedkoper per pen.",
        "solutionSteps": ["Winkel A: €1,20 per pen (al gegeven)", "Winkel B: €3,00 ÷ 3 = €1,00 per pen", "Vergelijk: €1,00 < €1,20", "Conclusie: Winkel B is 20 cent goedkoper per pen ✓"],
        "distractorExplanations": {
          "0": "Goed! Winkel B: €3,00 ÷ 3 = €1,00 per pen. Dat is 20 cent goedkoper dan €1,20 bij Winkel A.",
          "1": "Je dacht waarschijnlijk dat Winkel A goedkoper is omdat je daar maar 1 pen hoeft te kopen. Maar per stuk is Winkel A duurder: €1,20 vs. €1,00. Onthoud: vergelijk de prijs per stuk, niet het totaalbedrag.",
          "2": "Je dacht waarschijnlijk dat het niet uitmaakt. Maar €1,20 ≠ €1,00 — dat is 20 cent verschil per pen. Onthoud: bereken altijd de prijs per stuk om eerlijk te vergelijken.",
          "3": "Je dacht waarschijnlijk dat Winkel B duurder is omdat je €3,00 betaalt. Maar €3,00 is voor 3 pennen: €3,00 ÷ 3 = €1,00 per pen. Dat is goedkoper dan €1,20. Onthoud: kijk naar de prijs per stuk, niet naar het totaalbedrag."
        }
      }
    },
    {
      "id": "GELD-KOOPJES-004",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een sapproducent vergelijkt verpakkingen. Een fles sap van 1 liter kost €2,00. Een fles van 2 liter kost €3,50. Welke is goedkoper per liter?",
      "options": ["2 liter fles", "1 liter fles", "beide even duur", "kan je niet vergelijken"],
      "correctAnswer": 0,
      "conceptId": "price_comparison_volume",
      "variantIndex": 4,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.77,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Prijs per liter berekenen", "content": "1 liter fles: €2,00 ÷ 1 = €2,00/liter. 2 liter fles: €3,50 ÷ 2 = €1,75/liter. €1,75 < €2,00 → 2 liter fles is goedkoper per liter.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Bereken de prijs per liter door de totaalprijs te delen door het aantal liters. 1 liter fles: €2,00 ÷ 1 = €2,00/liter. 2 liter fles: €3,50 ÷ 2 = €1,75/liter. €1,75 < €2,00, dus de 2 liter fles is goedkoper per liter.",
        "solutionSteps": ["Bereken prijs per liter kleine fles: €2,00 ÷ 1 = €2,00/liter", "Bereken prijs per liter grote fles: €3,50 ÷ 2 = €1,75/liter", "Vergelijk: €1,75 < €2,00", "Conclusie: de 2 liter fles is 25 cent goedkoper per liter ✓"],
        "distractorExplanations": {
          "0": "Goed! 2 liter fles: €3,50 ÷ 2 = €1,75/liter. Dat is 25 cent goedkoper per liter dan de 1 liter fles.",
          "1": "Je dacht waarschijnlijk dat de laagste totaalprijs automatisch het goedkoopst is. €2,00 is minder dan €3,50, maar per liter is de 1 liter fles duurder: €2,00/liter vs. €1,75/liter. Onthoud: vergelijk de prijs per liter, niet de totaalprijs.",
          "2": "Je dacht waarschijnlijk dat het niet uitmaakt. Maar €2,00/liter ≠ €1,75/liter — dat is 25 cent verschil per liter. Onthoud: bereken de prijs per eenheid om eerlijk te vergelijken.",
          "3": "Je dacht waarschijnlijk dat je het niet kunt vergelijken. Maar deel de prijs door het aantal liters: €2,00 ÷ 1 = €2,00 en €3,50 ÷ 2 = €1,75. Onthoud: prijs per liter = totaalprijs ÷ aantal liters."
        }
      }
    },
    {
      "id": "GELD-KOOPJES-005",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een banketbakker vergelijkt koekjesleveranciers. Kleine doos (200 gram) voor €1,80 of grote doos (500 gram) voor €4,00. Welke is goedkoper per 100 gram?",
      "options": ["grote doos", "kleine doos", "beide even duur", "grote doos is duurder"],
      "correctAnswer": 0,
      "conceptId": "price_comparison_weight",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Prijs per 100 gram berekenen", "content": "Kleine doos: €1,80 ÷ 2 = €0,90 per 100g. Grote doos: €4,00 ÷ 5 = €0,80 per 100g. €0,80 < €0,90 → grote doos is goedkoper per 100g.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Bereken de prijs per 100 gram door de totaalprijs te delen door het gewicht in honderdtallen. Kleine doos: €1,80 ÷ 2 (= 200g/100) = €0,90 per 100g. Grote doos: €4,00 ÷ 5 (= 500g/100) = €0,80 per 100g. €0,80 < €0,90, dus de grote doos is goedkoper per 100 gram.",
        "solutionSteps": ["Bereken prijs per 100g kleine doos: €1,80 ÷ 2 = €0,90 per 100g", "Bereken prijs per 100g grote doos: €4,00 ÷ 5 = €0,80 per 100g", "Vergelijk: €0,80 < €0,90", "Conclusie: de grote doos is 10 cent goedkoper per 100g ✓"],
        "distractorExplanations": {
          "0": "Goed! Grote doos: €4,00 ÷ 5 = €0,80 per 100g. Dat is 10 cent goedkoper per 100g dan de kleine doos.",
          "1": "Je dacht waarschijnlijk dat de laagste totaalprijs automatisch het goedkoopst is. €1,80 is minder dan €4,00, maar per 100g is de kleine doos duurder: €0,90 vs. €0,80. Onthoud: vergelijk de prijs per 100 gram, niet de totaalprijs.",
          "2": "Je dacht waarschijnlijk dat het niet uitmaakt. Maar €0,90/100g ≠ €0,80/100g — dat is 10 cent verschil per 100 gram. Onthoud: bereken de prijs per eenheid om eerlijk te vergelijken.",
          "3": "Je dacht waarschijnlijk dat de grote doos duurder is omdat het totaalbedrag hoger is. De grote doos is duurder in totaal (€4,00 > €1,80), maar goedkoper per 100 gram (€0,80 < €0,90). Onthoud: kijk naar de prijs per eenheid, niet naar het totaalbedrag."
        }
      }
    },
    {
      "id": "GELD-KOOPJES-006",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een schoolinkoper wil 10 potloden bestellen. Losse potloden kosten €0,50. Een doos van 10 potloden kost €4,00. Hoeveel bespaart de school met de doos?",
      "options": ["€1,00", "€0,50", "€1,50", "€4,00"],
      "correctAnswer": 0,
      "conceptId": "price_comparison_bulk",
      "variantIndex": 6,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.80,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Totale besparing berekenen", "content": "Losse prijs: 10 × €0,50 = €5,00. Doosprijs: €4,00. Besparing: €5,00 − €4,00 = €1,00.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Bereken eerst de totale losse prijs, dan trek je de doosprijs af. Losse prijs voor 10 potloden: 10 × €0,50 = €5,00. Doosprijs: €4,00. Besparing = €5,00 − €4,00 = €1,00.",
        "solutionSteps": ["Bereken losse prijs: 10 × €0,50 = €5,00", "Doosprijs: €4,00", "Bereken besparing: €5,00 − €4,00 = €1,00", "Conclusie: de school bespaart €1,00 met de doos ✓"],
        "distractorExplanations": {
          "0": "Goed! 10 × €0,50 = €5,00 los. Besparing: €5,00 − €4,00 = €1,00.",
          "1": "Je dacht waarschijnlijk dat €0,50 de besparing is. Maar €0,50 is de prijs van één potlood, niet de totale besparing. Besparing = 10 × €0,50 − €4,00 = €5,00 − €4,00 = €1,00. Onthoud: bereken eerst de totale losse prijs.",
          "2": "Je dacht waarschijnlijk dat de besparing €1,50 is. Maar 10 × €0,50 = €5,00, en €5,00 − €4,00 = €1,00, niet €1,50. Onthoud: controleer je berekening: €4,00 + €1,00 = €5,00 ✓.",
          "3": "Je dacht waarschijnlijk dat €4,00 de besparing is. Maar €4,00 is wat je betaalt voor de doos, niet wat je bespaart. Besparing = losse prijs − doosprijs = €5,00 − €4,00 = €1,00. Onthoud: besparing = verschil tussen los en doos."
        }
      }
    },
    {
      "id": "GELD-KOOPJES-011",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "fill_in",
      "question": "Een pak van 6 flessen water kost €3,60. Hoeveel kost één fles? Typ het bedrag in euro's (bijv. 0,60).",
      "correctAnswer": "0,60",
      "data": {
        "acceptedAnswers": ["0,60", "€0,60", "0.60", "€0.60"],
        "placeholder": "prijs per fles in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Prijs per stuk", "content": "Prijs per stuk = totaalprijs ÷ aantal. €3,60 ÷ 6 = €0,60 per fles.", "icon": "lightbulb" } }
      ],
      "conceptId": "koopjes_fill_in_per_stuk",
      "variantIndex": 11,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Prijs per stuk = totaalprijs ÷ aantal. €3,60 ÷ 6 = €0,60 per fles. Reken in centen: 360 ÷ 6 = 60 cent = €0,60.",
        "solutionSteps": [
          "Totaalprijs: €3,60 = 360 cent",
          "Aantal: 6 flessen",
          "360 ÷ 6 = 60 cent = €0,60"
        ]
      }
    },
    {
      "id": "GELD-KOOPJES-012",
      "familyId": "GELD-KOOPJES",
      "module": "Geld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "fill_in",
      "question": "Winkel A verkoopt 4 pennen voor €3,00. Winkel B verkoopt 1 pen voor €0,80. Hoeveel bespaar je per pen als je bij winkel A koopt? Typ het bedrag in euro's (bijv. 0,05).",
      "correctAnswer": "0,05",
      "data": {
        "acceptedAnswers": ["0,05", "€0,05", "0.05", "€0.05"],
        "placeholder": "besparing per pen in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Besparing berekenen", "content": "Stap 1: Prijs per pen winkel A = €3,00 ÷ 4 = €0,75. Stap 2: Prijs per pen winkel B = €0,80. Stap 3: Besparing = €0,80 − €0,75 = €0,05 per pen.", "icon": "lightbulb" } }
      ],
      "conceptId": "koopjes_fill_in_besparing",
      "variantIndex": 12,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Prijs per pen winkel A: €3,00 ÷ 4 = €0,75. Prijs per pen winkel B: €0,80. Besparing per pen: €0,80 − €0,75 = €0,05.",
        "solutionSteps": [
          "Winkel A: €3,00 ÷ 4 = €0,75 per pen",
          "Winkel B: €0,80 per pen",
          "Besparing: €0,80 − €0,75 = €0,05 per pen"
        ]
      }
    }
  ]
}